import React from 'react';

const InstallBanner = ({ installable, dismissed, handleInstallClick, handleDismiss }) => {
    if (!installable || dismissed) return null;
    return (
        <div className="pwa-install-banner animate__animated animate__fadeIn">
            <div className="pwa-banner-content">
                <span className="pwa-banner-icon">📲</span>
                <div className="pwa-banner-text">
                    <strong>Instala Bryemma</strong>
                    <p>Accede más rápido y viaja seguro desde tu pantalla de inicio.</p>
                </div>
            </div>
            <div className="pwa-banner-actions">
                <button className="btn-install" onClick={handleInstallClick}>Instalar</button>
                <button className="btn-close" onClick={handleDismiss}>✕</button>
            </div>
        </div>
    );
};

export default InstallBanner;
